import { render } from "./SelectStaffRole.vue?vue&type=template&id=94b8bd88"
import script from "./SelectStaffRole.vue?vue&type=script&lang=js"
export * from "./SelectStaffRole.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__